export default [{
  path: '/translate',
  name: 'Translate',
  component: () => import('@/views/translate/translate')
}]
